export default __webpack_public_path__ + "static/media/interactions.5b5c0007.webp";